<template>
  <div class="content if-profile report-tab">
    <div class="md-layout if-profile-body">
      <SPIFReportHeader :headerData="this.headerData"/>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4 fundamentals_wpr profit-loss"
      >
        <h1 class="section_header">Cash Tables</h1>

        <div
          class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0 mt-4"
        >
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab
                  id="tab-payments"
                  md-label="Dollars"
                  md-icon="payments"
                  class="p-0"
                >
                  <div class="md-layout-item md-size-100 if_card">
                    <md-card-header>
                      Annual Cash Ratios ($)
                    </md-card-header>
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                        >
                          <md-table
                            v-model="tableAnnualCashRatiosDollar"
                            table-header-color="blue"
                            class="profit-and-loss-table"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell class="md-table-side-label">
                                {{ item.name }}
                                <md-tooltip md-direction="bottom">{{
                                  item.rollover
                                }}</md-tooltip>
                              </md-table-cell>
                              <md-table-cell
                                v-for="key in Object.keys(item.dates)"
                                :key="key"
                                :md-label="key"
                                >{{ item.dates[key] }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>

                          <md-table
                            v-model="worksheet"
                            table-header-color="blue"
                            class="sources-users-table"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell md-label="Worksheet">{{
                                item.title
                              }}</md-table-cell>
                              <md-table-cell
                                v-for="key in Object.keys(item.dates)"
                                :key="key + 'worksheet'"
                                :md-label="key"
                                >{{ item.dates[key] }}</md-table-cell
                              >
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </md-tab>
                <md-tab
                  id="tab-money"
                  md-label="Percentages"
                  md-icon="money"
                  class="p-0"
                >
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header>
                        Annual Cash Ratios (%)
                      </md-card-header>
                      <md-card-content>
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                          >
                            <md-table
                              v-model="tableAnnualCashRatiosPercent"
                              table-header-color="blue"
                              class="profit-and-loss-table"
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                              >
                                <md-table-cell class="md-table-side-label">
                                  {{ item.name }}
                                  <md-tooltip md-direction="bottom">{{
                                    item.rollover
                                  }}</md-tooltip>
                                </md-table-cell>
                                <md-table-cell
                                  v-for="key in Object.keys(item.dates)"
                                  :key="key"
                                  :md-label="key"
                                  >{{ item.dates[key] }}
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import SPIFReportHeader from './_partials/SPIFHeader.vue';
import formatData from '@/mixins/format-data';

export default {
  components: {
    SPIFReportHeader,
    NavTabsCard,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      changein: [],
      worksheet: [],
      tableAnnualCashRatiosDollar: [],
      tableAnnualCashRatiosPercent: [],
      display_source_uses: false,
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.report.data.data,
      showYears: (state) => state.user.report.data.showYears,
      annualCashRatiosDollar: (state) =>
        state.user.report.data.tables.annual_cash_ratios_dollar,
      annualCashRatiosPercent: (state) =>
        state.user.report.data.tables.annual_cash_ratios_percent,
      report: (state) => state.user.report.data,
    }),
  },
  mounted() {
    let filtered_years = [];
    Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k] && this.years) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }

    this.tableAnnualCashRatiosDollar = this.formatTable(
      this.annualCashRatiosDollar,
      'industry',
      'dollar'
    );
    this.tableAnnualCashRatiosDollar = this.tableAnnualCashRatiosDollar.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return filtered_years && !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );

    this.tableAnnualCashRatiosPercent = this.formatTable(
      this.annualCashRatiosPercent,
      'industry',
      'percent'
    );
    this.tableAnnualCashRatiosPercent = this.tableAnnualCashRatiosPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return filtered_years && !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );
  },
  methods: {
    formatData(table, data) {
      let getDates = (id) =>
        this.years.reduce((acc, cur, index) => {
          let value = this.actualData[this.years.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
